export const TrackerId = "323666067";

export enum EventActions {
    AppAccessed = "App Accessed",
}
